/**
 * Celda de tabla que contiene un campo editable: sin recorte con "…" (las tablas de ancho fijo
 * recortan el contenido) y con menos alto, para que el campo quede alineado en la fila.
 */
export const TABLE_INPUT_CELL_SX = { py: 0.5, px: 1, overflow: 'visible', textOverflow: 'clip' };

/** Campo dentro de una celda: ocupa el ancho de la columna y no suma margen arriba. */
export const TABLE_INPUT_SX = { mt: 0, width: '100%' };
